import { render, staticRenderFns } from "./Info.global.vue?vue&type=template&id=7c9efec5&lang=pug&"
import script from "./Info.global.vue?vue&type=script&lang=ts&"
export * from "./Info.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports